const Footer = () => {
    return (
        <footer className="footer">
            <p><small>Thank you for checking out my <a href="https://github.com/robelsiam/personalwebsite" 
            target="_blank" rel="noreferrer">open source</a> website!</small></p>
        </footer>
    );
}

export default Footer;